import React, { useMemo } from 'react';
import { displayToEditorHtml } from '../utils/htmlMarkers';

function MarkerRichText({ displayWithMarkers, tagMap, entityMap, className }) {
  const html = useMemo(
    () => displayToEditorHtml(displayWithMarkers || '', tagMap || {}, entityMap || {}),
    [displayWithMarkers, tagMap, entityMap],
  );

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: html || '&nbsp;' }}
    />
  );
}

export default MarkerRichText;
